import { result } from 'lodash';

export const copyAndSort = (items, key, isSortedDescending) => {
  if (!key) {
    return items;
  }

  return items.slice(0).sort((a, b) => ((isSortedDescending ?
    result(a, key) < result(b, key) :
    result(a, key) > result(b, key)) ? 1 : -1));
};
